var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankingStarSolid1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 54,
    viewBox: "0 0 66 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3255_11513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4856 6.10022L34.0519 1.15218C33.6497 0.292996 32.3916 0.261941 31.9481 1.15218L29.5144 6.10022L24.1209 6.87659C23.1619 7.02151 22.7494 8.21194 23.4609 8.9262L27.3797 12.7563L26.4516 18.1494C26.3072 19.1121 27.2972 19.8574 28.1841 19.4123L33.0206 16.8451L37.8262 19.3709C38.7131 19.816 39.7134 19.0707 39.5588 18.108L38.6306 12.7149L42.5494 8.9262C43.2506 8.22229 42.8484 7.03186 41.8894 6.87659L36.4959 6.10022H36.4856ZM26.4 27C24.5747 27 23.1 28.4803 23.1 30.3125V50.1875C23.1 52.0197 24.5747 53.5 26.4 53.5H39.6C41.4253 53.5 42.9 52.0197 42.9 50.1875V30.3125C42.9 28.4803 41.4253 27 39.6 27H26.4ZM3.3 33.625C1.47469 33.625 0 35.1053 0 36.9375V50.1875C0 52.0197 1.47469 53.5 3.3 53.5H16.5C18.3253 53.5 19.8 52.0197 19.8 50.1875V36.9375C19.8 35.1053 18.3253 33.625 16.5 33.625H3.3ZM46.2 43.5625V50.1875C46.2 52.0197 47.6747 53.5 49.5 53.5H62.7C64.5253 53.5 66 52.0197 66 50.1875V43.5625C66 41.7303 64.5253 40.25 62.7 40.25H49.5C47.6747 40.25 46.2 41.7303 46.2 43.5625Z",
    fill: "#8DAF61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3255_11513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 53,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankingStarSolid1);
export default __webpack_public_path__ + "static/media/ranking-star-solid 1.97e334223e7dac6f66f71b933e1b91ab.svg";
export { ForwardRef as ReactComponent };